import { Router } from '@angular/router';
import { SectorModel } from '../service/sector.model';
import { DBConnectorService } from './../service/test.service';
import { TrainService } from '../service/train.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggedInGuard } from '../authentication/logged-in.guard';

@Component({
  selector: 'app-train',
  templateUrl: './train.component.html',
  styleUrls: ['./train.component.css'
  ]
})
export class TrainComponent implements OnInit, OnDestroy {

  Sub: Subscription;
  ErrorMessage: string;
  ModelStatus: string;
  Status: string;
  Admin = false;
  RoleId = '';

  result:any = {};
  sectormodel = new SectorModel;


  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private router: Router,
    private loggedInGuard: LoggedInGuard) {
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.Admin = this.dbconnectorservice.Admin;
    this.RoleId = this.dbconnectorservice.RoleID;
    this.dbconnectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.dbconnectorservice.onGetMod.subscribe((res) => {
      this.sectormodel.ModelName = res;
      this.StatusCheck();
    });
  }

  step2() {
    if (this.loggedInGuard.isSessionValid()) {
      if (this.sectormodel.SectorName != null && this.sectormodel.SectorName !== 'null') {
        this.result = {};
        this.trainservice.Step2(this.sectormodel)
          .subscribe(
            (data) => {
              this.result = data;
              if (this.result['TrainError'] == null) {
                this.router.navigate(['Train/Step2']);
              }
              // console.log(this.result);
            });
      } else {
        this.result['TrainError'] = 'Sector and Model have not been selected!';
      }
    }
  }

  step2new() {
    if (this.loggedInGuard.isSessionValid()) {
      if (this.sectormodel.SectorName != null && this.sectormodel.SectorName !== 'null') {
        this.result = {};
        this.trainservice.Step2New(this.sectormodel)
          .subscribe(
            (data) => {
              this.result = data;
              if (this.result['Train2Error'] == null) {
                this.router.navigate(['Train/Step2NewData']);
              }
              // console.log(this.result);
            });
      } else {
        this.result['Train2Error'] = 'Sector and Model have not been selected!';
      }
    }
  }

  StatusCheck() {
    this.trainservice.statusCheck(this.sectormodel)
      .subscribe(
        (data) => {
          this.Status = data;
          if (this.Status === 'TRAINING') {
            this.router.navigate(['Train/Step3']);
          } else if (this.Status === 'PROCESSING EXIST') {
            this.router.navigate(['Train/Step2']);
          } else if (this.Status === 'PROCESSING NEW') {
            this.router.navigate(['Train/Step2NewData']);
          } else {
            const status = this.Status.split(':');
            this.ModelStatus = status[0];
            this.ErrorMessage = status[1];
          }

          console.log(this.Status);
        });
  }

  step2UploadTrainxls() {
    if (this.loggedInGuard.isSessionValid()) {
      if (this.sectormodel.SectorName != null && this.sectormodel.SectorName !== 'null') {
        this.result = {};
        this.trainservice.trainwithxls(this.sectormodel)
          .subscribe(
            (data) => {
              this.result = data;
              if (this.result['TrainError'] == null) {
                this.router.navigate(['Train/trainwithxls']);
              }
              // console.log(this.result);
            });
      } else {
        this.result['TrainError'] = 'Sector and Model have not been selected!';
      }
    }
  }

  ngOnInit() {
    this.StatusCheck();
  }

  ngOnDestroy() {
    if (this.Sub != null) {
      this.Sub.unsubscribe();
    }
  }

}
